/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserEntity } from './UserEntity';
import {
    UserEntityFromJSON,
    UserEntityFromJSONTyped,
    UserEntityToJSON,
    UserEntityToJSONTyped,
} from './UserEntity';

/**
 * 
 * @export
 * @interface RoleEntity
 */
export interface RoleEntity {
    /**
     * ロールID
     * @type {string}
     * @memberof RoleEntity
     */
    id: string;
    /**
     * テナントID
     * @type {string}
     * @memberof RoleEntity
     */
    tenantId: string;
    /**
     * ロール名
     * @type {string}
     * @memberof RoleEntity
     */
    name: string;
    /**
     * ロール種別
     * 'custom'または'preset'
     * @type {string}
     * @memberof RoleEntity
     */
    type: string;
    /**
     * システム実行ポリシー
     * @type {Array<object>}
     * @memberof RoleEntity
     */
    systemActionPolicies: Array<object>;
    /**
     * 作成日時
     * @type {Date}
     * @memberof RoleEntity
     */
    createdAt: Date;
    /**
     * 最終更新日時
     * @type {Date}
     * @memberof RoleEntity
     */
    updatedAt: Date;
    /**
     * 作成ユーザー
     * @type {UserEntity}
     * @memberof RoleEntity
     */
    createdBy: UserEntity;
    /**
     * 最終更新ユーザー
     * @type {UserEntity}
     * @memberof RoleEntity
     */
    updatedBy: UserEntity;
}

/**
 * Check if a given object implements the RoleEntity interface.
 */
export function instanceOfRoleEntity(value: object): value is RoleEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('systemActionPolicies' in value) || value['systemActionPolicies'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    return true;
}

export function RoleEntityFromJSON(json: any): RoleEntity {
    return RoleEntityFromJSONTyped(json, false);
}

export function RoleEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tenantId': json['tenantId'],
        'name': json['name'],
        'type': json['type'],
        'systemActionPolicies': json['systemActionPolicies'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'createdBy': UserEntityFromJSON(json['createdBy']),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
    };
}

export function RoleEntityToJSON(json: any): RoleEntity {
    return RoleEntityToJSONTyped(json, false);
}

export function RoleEntityToJSONTyped(value?: RoleEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'type': value['type'],
        'systemActionPolicies': value['systemActionPolicies'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdBy': UserEntityToJSON(value['createdBy']),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
    };
}

